/**
 * Created by Jie Gao on 2021-03-11.
 */

export interface BitmapFontStyleData {
    fontName:string;
    fontSize?:number;
    align?:string;
    tint?:number;
    letterSpacing?:number;
    maxWidth?:number;
}

export class FontStyleConfig {
    public static readonly Evil4Multiplier:BitmapFontStyleData = {
        fontName:"multiplierCountup",
        fontSize:13,
        tint:PIXI.utils.string2hex("#ffffff")
    };

    public static readonly Evil4MultiplierOnSymbol:BitmapFontStyleData = {
        fontName:"evilMultiplier",
        fontSize:30,
        tint:PIXI.utils.string2hex("#ffffff")
    };

    public static readonly SpinsMultiplier:BitmapFontStyleData = {
        fontName:"multiplier-yellow",
        fontSize:50,
        align:"center",
        tint:PIXI.utils.string2hex("#ffffff")
    };

    public static readonly CountUp:BitmapFontStyleData = {
        fontName:"EvilGoblins_countUp",
        fontSize:50,
        tint:PIXI.utils.string2hex("#ffffff")
    };

    public static readonly WildMultiplier:BitmapFontStyleData = {
        fontName:"EvilGoblins_countUp",
        fontSize:12,
        tint:PIXI.utils.string2hex("#ffffff")
    };

    public static readonly FSNUMBEROnFSIntro:BitmapFontStyleData = {
        fontName:"ways",
        fontSize:90
    };
}